import { AbstractControl } from '@angular/forms';
/**
 * It returns a function that takes an AbstractControl as an argument and returns
 * null if the password and confirm password fields are equal, otherwise it returns
 * an object with a key of passwordIsNotEqual and a value of true
 * @param {string} passwordControl - The name of the control that contains the
 * password.
 * @param {string} confirmControl - The name of the control that contains the
 * password confirmation.
 * @returns A function that takes in an AbstractControl and returns an object or
 * null.
 */
export const passwordEqualValidation = (
  passwordControl: string,
  confirmControl: string
) => {
  return (control: AbstractControl) => {
    const password = control.get(passwordControl);
    const confirm = control.get(confirmControl);

    if (!password || !confirm) {
      return null;
    }

    if (password.value !== confirm.value) {
      confirm.setErrors({ passwordIsNotEqual: true });
    } else {
      // Si ya tenía un error 'passwordIsNotEqual', limpiarlo
      if (confirm.hasError('passwordIsNotEqual')) {
        confirm.setErrors(null);
      }
    }

    return null;
  };
};

const capitalLetterPattern = /^(?=.*?[A-Z])/g;
const lowercasePattern = /^(?=.*?[a-z])/g;
const numberPattern = /^(?=.*?[0-9])/g;
const specialCharacterPattern = /^(?=.*?[!@#$%^&*])/g;

/**
 * Funcion que aplica una seria de validaciones al formato de una contraseña
 * @param control {AbstractControl}
 * @returns Estado de la validacion
 */
export const passwordValidation = (control: AbstractControl) => {
  let validation = null;
  const value = control?.value as string;

  if (!value) {
    return null;
  }

  const hasMinimumLength = value?.length >= 10;
  const hasNumbers = !!value?.match(numberPattern);
  const hasCapitalLetters = !!value?.match(capitalLetterPattern);
  const hasLowercase = !!value?.match(lowercasePattern);
  const hasSpecialCharacters = !!value?.match(specialCharacterPattern);

  if (
    !hasMinimumLength ||
    !hasNumbers ||
    !hasCapitalLetters ||
    !hasLowercase ||
    !hasSpecialCharacters
  ) {
    if (!validation) {
      validation = {};
    }

    if (!hasMinimumLength) {
      validation = { ...validation, hasMinimumLength: true };
    }
    if (!hasNumbers) {
      validation = { ...validation, hasNumbers: true };
    }
    if (!hasCapitalLetters) {
      validation = { ...validation, hasCapitalLetters: true };
    }
    if (!hasLowercase) {
      validation = { ...validation, hasLowercase: true };
    }
    if (!hasSpecialCharacters) {
      validation = { ...validation, hasSpecialCharacters: true };
    }

    validation = { invalidPassword: { ...validation } };
  }

  return validation;
};
